export const widthFull = { width: '100%' };